<style scoped lang="less">
.box {
    height: 1450px;
}
.box::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    height: 1550px;
    width: 100vw;
}

.head-wrapper {
    color: white;
    .cover {
        position: relative;
        height: 370px;
        .circel {
            // background-image: url(http://static.unicornselected.com/FvWpsjBWZCCtu-05S457QV7OEyWd);
            // background-size: 100% 100%;
            position: relative;
            top: 40px;
            // margin: 0 auto;
            // width: 370px;
            // height: 255px;

            .introduce {
                position: relative;
                top: 65px;
                .aboutOur {
                    margin: 0 auto;
                    position: relative;
                    bottom: 5px;

                    > span {
                        font-size: 36px;
                    }
                }
                .text {
                    .reds {
                        font-size: 16px;
                        font-weight: 500;
                        color: #bc242b;
                    }
                }
            }
        }
    }
    .cover::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -1;
        height: 370px;
        width: 100vw;
        background-image: url('http://static.unicornselected.com/b45017f0-0335-11eb-91c5-d550a48abe82.jpeg');
        background-size: 100% 100%;
        filter: brightness(0.6);
    }
}

.faq {
    width: 1300px;
    height: 1000px;
    margin: 100px auto;
    .faq-container {
        width: 1300px;
        display: flex;
        flex-wrap: wrap;
        > img {
            margin: 0 auto;
            width: 325px;
            height: 60px;
        }
        .faqBox {
            width: 645px;
            height: 350px;
            margin-bottom: 50px;
            .f {
                height: 100px;
                background-color: #f7f7f7;
                border-bottom: 1px solid #fff;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                .icon-duihuaxinxitianchong {
                    margin-left: 30px;
                    color: #bc242b;
                    font-size: 40px;
                }
                > span {
                    margin-left: 10px;
                    font-size: 20px;
                }
            }
            .q {
                height: 250px;
                background-color: #f7f7f7;
                padding: 20px;
                overflow: scroll;
                .q-content {
                    text-align: left;
                }
                .q-content:nth-child(n + 2) {
                    margin-top: 19px;
                    text-align: left;
                }
            }
        }
        .faqBox:nth-child(2n) {
            margin-left: 10px;
        }
    }
}

.footer {
    margin-top: 2500px;
}
.title-container {
    margin-bottom: 30px;
    > span {
        font-size: 33px;
        color: #9e272e;
        font-weight: 700;
    }
}
</style>

<template>
  <div class="box">
    <div class="head-wrapper">
      <div class="cover">
        <div class="circel">
          <div class="introduce">
            <div class="aboutOur">
              <span class="aboutUs">FAQ问答</span>
              <div class="english">
                <span class="tnr">Frequently Asked Question</span>
              </div>
            </div>
            <div class="inline"></div>
            <span class="text">
              <span class="reds"></span>
            </span>
            <div class="english"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="faq">
      <div class="faq-container">
        <div class="faqBox" v-for="(it) in faqNormal" :key="it.id">
          <div class="f">
            <i class="iconfont icon-duihuaxinxitianchong"></i>
            <span>{{it.f}}</span>
          </div>
          <div class="q">
            <div class="q-content" v-for="(itt, index) in it.q" :key="index">{{itt}}</div>
          </div>
        </div>
      </div>

      <!-- <img
        style="marginBottom:30px"
        src="http://static.unicornselected.com/Fnzr8mIXYTK9cCOka1yQXFBnM7Wd"
        alt
      >-->
      <div class="title-container">
        <span>对投资者</span>
      </div>
      <div class="faq-container">
        <div class="faqBox" v-for="(it) in toInvestors" :key="it.id">
          <div class="f">
            <i class="iconfont icon-duihuaxinxitianchong"></i>
            <span>{{it.f}}</span>
          </div>
          <div class="q">
            <div class="q-content" v-for="(itt, index) in it.q" :key="index">{{itt}}</div>
          </div>
        </div>
      </div>
      <!-- <img
        style="marginBottom:30px"
        src="http://static.unicornselected.com/Fn8eYp10H1x-qxS0V5NiE1BjY8DA"
        alt
      >-->
      <div class="title-container">
        <span>对转让方</span>
      </div>
      <div class="faq-container">
        <div class="faqBox" v-for="(it) in toAssignor" :key="it.id">
          <div class="f">
            <i class="iconfont icon-duihuaxinxitianchong"></i>
            <span>{{it.f}}</span>
          </div>
          <div class="q">
            <div class="q-content" v-for="(itt, index) in it.q" :key="index">{{itt}}</div>
          </div>
        </div>
      </div>
    </div>

    <bottom class="footer"></bottom>
  </div>
</template>

<script>
import Bottom from '../components/bottom';
export default {
    components: {
        Bottom,
    },
    data() {
        return {
            faqNormal: [
                {
                    f: '什么是私募股权二级市场（PE Secondary）？',
                    q: [
                        '私募股权二级市场（PE Secondary）主要指从已经存在的LP手中购买相应的私募股权权益，也包括从GP手中购买私募股权基金中部分或所有的投资组合。二级市场出现的意义在于满足现有投资人的获得流动性的需求，是PE基金的一项新的退出渠道。',
                        '卖家可能因为各种原因需要卖出项目公司股权或其LP份额：新项目资金需求；基金产品赎回或到期兑付压力；政策法规变化；资产配置需求变化；公司高管改善个人生活需求等。',
                        '买家也有各种各样的考虑：PE Secondary往往存在折价，可以优惠价格进入目标公司并获得一定安全垫；看好项目公司但是没有获得足够的份额，为了提升影响力与产业协同而提高股权占比；机构收益风险匹配资产配置需求等。',
                    ],
                },
                {
                    f: '独角兽老股转让市场有什么特征？',
                    q: [
                        '独角兽公司是私募股权市场顶部的那颗明珠，代表了各个新兴领域内最优秀的公司。独角兽公司的特点是：公司增长确定性较高且风险可控、公众关注度高、公司治理结构完善、知名投资机构背书增信。在信息相对不透明的私募股权市场，独角兽公司因为更加透明所以交易摩擦更低，成为私募股权市场中流动性最好的优质资产。',
                    ],
                },
                {
                    f: '关于独角汇？',
                    q: [
                        '独角汇致力于减少股权交易过程中的摩擦，提升独角兽项目股权的流动性，推动私募股权二级市场的快速扩容。公司会通过以下三点努力实现这一目标：',
                        '-  ­	作为信息中介平台，减少寻找交易对手的时间成本与经济损耗，提高双方的沟通效率；',
                        '-   ­作为信用增信平台，核实买卖家真实身份与底层材料，确保交易可靠；',
                        '-   经验丰富的团队对接，全程陪伴交易的谈判与协调，外接中介服务机构，提供交易架构设计、法律、税务、跨境交易等咨询服务。',
                        '- 运用自有数据库配合内部算法，优选潜在交易对手；通过标准化内部流程和信息系统，把控交易全程。',
                    ],
                },
                {
                    f: '平台可以提供什么服务？',
                    q: [
                        '平台可在公开信息的范围内（公司融资历史、行业新闻等）尽力为投资者提供资料、根据独角兽项目二级市场的热度给出报价指引，还能为投资者介绍长期合作的三方服务机构。平台拥有广泛的社会网络，亦可在需要时为投资者引荐项目公司。然而投资者须知，上述服务本身不构成任何投资意见，最终相关交易决策应基于其独立判断，平台不承担任何交易与投资风险。',
                    ],
                },
                {
                    f: '什么是独角兽公司股权直接与间接投资？',
                    q: [
                        '直接投资意味着进入公司的股东名册，但由于不少创业公司希望控制股东人数规模，所以对股权转让施加了诸多限制，一般来说，投资规模大、具有产业协同性的投资人更易获得公司方认可。间接投资常见于持有股东名册SPV的股权或LP份额，间接投资可以接受的投资额度与投资者背景较直接投资更为灵活宽松。',
                    ],
                },
                {
                    f: '投资独角兽公司需要注意哪些法律合规上的问题？',
                    q: [
                        '由于不少创业公司对老股或份额转让设定了限制条款，平台会与投资人的律师、公司方紧密沟通交流，设计相应交易结构以确保顺利交割。不少独角兽公司还设立了境外VIE架构，您可能需要在资金出境、税务方面咨询专业机构。此外，个人投资者应当具备合格投资人资格。',
                    ],
                },
                {
                    f: '创业公司为什么要支持老股转让？',
                    q: [
                        '由于老股转让潜在地增加了市场上的股权供给，且往往交易估值相较市场水平有一定折让，创业公司往往担心老股市场会拉低公司估值并影响后续融资。但我们认为，交易的折价主要来自流动性折价，为卖家快速获取流动性的自然结果，并非估值下降。而只要买卖双方的需求客观存在，老股转让市场就会持续存在。公司股权的流动性提高，反而会打消早期投资人的退出疑虑、改善公司员工的生活水平，让投资人更放心地投资、员工更努力地工作，最终实现公司价值的提升。无论是在老股转让二级市场，还是员工股权激励变现方面，平台都愿意配合独角兽公司进行相关管理。具体交易中，平台会根据买卖方需求，积极与创业公司沟通，以顺利地完成股权/份额交割。',
                    ],
                },
            ],
            toInvestors: [
                {
                    f: '谁可以投资？',
                    q: [
                        '我们欢迎任何拥有投资意愿与投资能力的投资机构、具备合格投资人资格的超高净值投资人通过平台获取独角兽项目投资资讯（具体参照当地法律及行业规则）。投资者应当熟知并接受私募股权二级市场的高风险、流动性不足、信息有限等特点，并且拥有合规、法务、税务方面的知识及专业支持。',
                    ],
                },
                {
                    f: '交易流程是怎样的？',
                    q: [
                        '-  ­	注册并认证独角汇账户',
                        '注册成为独角汇平台用户，并及时上传名片补充个人信息，若信息通过审核，平台会在24小时内完成用户认证。',
                        '-   ­浏览项目信息',
                        '注册用户可以自由浏览平台展示项目信息，获取最新融资情况与新闻资讯。',
                        '­- 	提交项目意向',
                        '注册用户可以在具体项目内提交受让意向，认证用户意向会优先得到匹配与反馈。',
                        '-   ­平台资料审核及文件签署',
                        '平台审核资金证明、相关KYC资料等，同时签署财务顾问协议与保密协议等。',
                        '-   交易洽谈与合同签署',
                        '平台协助设计交易结构并安排电话会议进行交易洽谈、交易条款沟通调整及定稿、合同签署。',
                        '-   ­完成交割',
                        '双方履约，完成交割及相关支付义务。',
                    ],
                },
                {
                    f: '交易费用是怎样的？',
                    q: [
                        '为减少交易摩擦，平台提供市场上有竞争力的收费水平，原则上按照交易对价的1%收取财务顾问费，但可能由于交易规模、额外服务等情况进行调整。在有推荐人的情况下，平台会统一管理交易佣金的收取（除非单独约定），在交易完成后向推荐人统一支付居间费用。',
                    ],
                },
            ],
            toAssignor: [
                {
                    f: '谁可以转让？',
                    q: [
                        '我们欢迎独角兽公司的早期投资人、创业公司高管通过平台转让其持有的普通股、优先股、已解禁的股权激励或期权，或是对应的股权份额。未解禁的股权激励虽然无法即时转让，我们也可提供定制化服务进行流动性安排。',
                    ],
                },
                {
                    f: '交易流程是怎样的？',
                    q: [
                        '-  ­	注册并认证独角汇账户',
                        '注册成为独角汇平台用户，并及时上传名片补充个人信息，若信息通过审核，平台会在24小时内完成用户认证。',
                        '-   ­浏览项目信息',
                        '注册用户可以自由浏览平台展示项目信息，获取最新融资情况与新闻资讯。',
                        '­- 	提交项目意向',
                        '注册用户可以在具体项目内提交转让意向，认证用户意向会优先得到匹配与反馈。',
                        '-   ­平台资料审核及文件签署',
                        '平台审核持股证明、相关KYC资料等，同时签署财务顾问协议与保密协议等。',
                        '-   交易洽谈与合同签署',
                        '平台协助设计交易结构并安排电话会议进行交易洽谈、交易条款沟通调整及定稿、合同签署。',
                        '-   ­完成交割',
                        '双方履约，完成交割及相关变更义务。',
                    ],
                },
                {
                    f: '交易费用是怎样的？',
                    q: [
                        '为减少交易摩擦，平台提供市场上有竞争力的收费水平，原则上按照交易对价的1%收取财务顾问费，但可能由于交易规模、额外服务等情况进行调整。在有推荐人的情况下，平台会统一管理交易佣金的收取（除非单独约定），在交易完成后向推荐人统一支付居间费用。',
                    ],
                },
            ],
        };
    },

    methods: {},
};
</script>
